/**
 * Copyright (c) 2017.  INTERIA.PL (www.interia.pl)
 **/

/**
 * Created by vladyslav on 27.11.17.
 */
import { OFFSET_TOP } from './config';

export default class AdsSidebar {

    constructor({ element, ads = [], offsetTop = 0, contentHeight, adHeights }) {

        this.element = element;
        this.ads = ads;
        this.offsetTop = offsetTop;
        this.contentHeight = contentHeight;
        this.adHeights = adHeights;

    }

    set ads(ads) {
        this._ads = ads;
    }

    get ads() {
        return this._ads;
    }

    set contentHeight(contentHeight) {
        this._contentHeight = contentHeight;
    }

    get contentHeight() {
        return this._contentHeight;
    }

    set adHeights(adHeights) {
        this._adHeights = adHeights;
    }

    get adHeights() {
        return this._adHeights;
    }

    /**
     * calculate offset top
     */
    calcOffsetTop() {
        this.offsetTop = this.element.offsetTop - OFFSET_TOP;
    }

    /**
     * get ads elements
     * @returns {Array}
     */
    getAdsElements() {
        return this.ads.map(ad => ad.element);
    }

    /**
     * get last ad
     * @returns {Ad}
     */
    getLastAd() {
        return this.ads[this.ads.length - 1];
    }
}



// WEBPACK FOOTER //
// ./source/AdsSidebar.js